import React from 'react'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ErrorState from './ErrorState'
import { selectPermissions, can } from '../../lib/permissions'

/**
 * @param {{ needs: string, children: React.ReactNode, title?: string }} props
 */
export default function ProtectedFeatureRoute({ needs, children, title = 'Access restricted' }) {
  const permissions = useSelector(selectPermissions)
  if (can(permissions, needs)) return children

  return (
    <Box>
      <ErrorState
        title={title}
        description="You do not have permission to access this admin area. Contact a supervisor if access is required."
      />
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        Required permission: {needs}
      </Typography>
    </Box>
  )
}
